﻿import * as React from 'react';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FormElementViewModel from '../../ViewModels/FormElementViewModel';
import HelpIcon from '@material-ui/icons/Help';
import LightTooltip from '../../Utilities/LightTooltip';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import KeyboardDateValidator from '../../Utilities/KeyboardDateValidator';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

interface IProps {
    element: FormElementViewModel;
    onChange: (value: string, key: number) => void;
    setShouldSubmit: (key: number) => void;
}

export default function DateInput(props: IProps) {
    const { element, onChange, setShouldSubmit } = props;
    const [date, setDate] = React.useState<Date | null>(null);
    const [naChecked, setNaChecked] = React.useState<boolean>(false);

    const handleDateChange = (date: MaterialUiPickersDate, value?: string | null) => {
        if (!value) {
            value = '';
        }
        onChange(value, element.id);
        setDate(date);
    }

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked ? "N/A" : '', element.id);
        setNaChecked(event.target.checked);
        setDate(null);
    }

    React.useEffect(() => {
        setShouldSubmit(element.id);
    }, []);

    return (
        <React.Fragment>
            <Grid item xs={12}><Typography>{element.text}   {element.helpText &&
                <LightTooltip title={element.helpText} arrow>
                    <HelpIcon style={{ height: '20px' }} color="secondary" />
                </LightTooltip>
            }</Typography>
            </Grid>

            <Grid item xs={10}>
                {naChecked ?
                    <Typography>N/A</Typography> //display na if checkbox selected
                    :
                    <KeyboardDateValidator
                        clearable
                        format="dd/MM/yyyy"
                        name={element.documentPlaceholder}
                        fullWidth
                        value={date}
                        inputValue={element.value}
                        onChange={handleDateChange}
                        KeyboardButtonProps={{
                            style: { color: '#1616b1' }
                        }}
                        validators={element.required ? ['required'] : []}
                        errorMessages={element.required ? ['This field is required'] : []}
                    />
                }
            </Grid>
            <Grid item xs={2}>
                <FormControlLabel
                    label="is N/A"
                    control={
                        <Checkbox
                            name={element.documentPlaceholder + 'NACheck'}
                            color="secondary"
                            checked={naChecked}
                            onChange={handleCheckboxChange}
                            inputProps={{ 'aria-label': element.friendlyName + ' checkbox' }}
                            icon={<CheckBoxOutlineBlankIcon style={{ fontSize: '2.5rem' }} />}
                            checkedIcon={<CheckBoxIcon style={{ fontSize: '2.5rem' }} color="primary" />}
                        />
                    }
                />
            </Grid>

        </React.Fragment>
    );
}